import { useState } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import BookDemoModal from "../BookDemoModal";
import BookDemoContext from "../../context/BookDemoContext";

function Layout() {
  const [isBookDemoOpen, setIsBookDemoOpen] = useState(false);

  return (
    <BookDemoContext.Provider
      value={{
        openBookDemo: () => setIsBookDemoOpen(true),
        closeBookDemo: () => setIsBookDemoOpen(false),
      }}
    >
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer />
      <BookDemoModal
        isOpen={isBookDemoOpen}
        onClose={() => setIsBookDemoOpen(false)}
      />
    </BookDemoContext.Provider>
  );
}

export default Layout;
